<template>
    <div class="statistica__summary">
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Временные рамки достижения инвестиционных целей.'"
                        :direction = "'right'"></des>
                <span>Срок торговли по стратегии, дней</span></div>
            <div class="statistica__summary-item-data  f-stat-data">{{getDay}}</div>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Величина собственных активов трейдера и средств инвесторов, находящихся под управлением.'"
                        :direction = "'right'">
                </des>
                <span>СРЕДСТВ ПОД УПРАВЛЕНИЕМ</span></div>
            <data-watcher :data="bl" :units="'$'" :mod="3"></data-watcher>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Cовокупный финансовый результат всех закрытых сделок и не торговых операций по счету (прибыли\убытки, комиссии, пополнения\снятия).'"
                        :direction = "'right'"></des>
                        <span>Баланс счета</span></div>
            <data-watcher :data="bl" :units="'$'" :mod="3"></data-watcher>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                 <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Показатель, демонстрирующий уровень максимальных потерь депозита за период торговли.'"
                        :direction = "'right'"></des>
                        <span>МАКСИМАЛЬНАЯ ПРОСАДКА (MAX. DD)</span></div>
            <div class="statistica__summary-item-data  f-stat-data f-stat-data--down">6%</div>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Денежные ресурсы счета с учетом текущих позиций (баланс + floating profit/loss).'"
                        :direction = "'right'"></des>
                        <span>СРЕДСТВА</span></div>
            <data-watcher :data="eq" :units="'$'" :mod="3"></data-watcher>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Разница между общей прибылью и общим убытком за расчетный период.'"
                        :direction = "'right'"></des>
                        <span>Чистая прибыль, $</span></div>
            <data-watcher :data="cleanProfit" :units="'$'" :mod="3"></data-watcher>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Разница между общей прибылью и общим убытком за расчетный период.'"
                            :direction = "'right'"></des>
                            <span>Чистая прибыль, pip</span></div>
            <data-watcher :data="cleanProfitPoint" :mod="3"></data-watcher>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Отношение заемных средств, выделяемых брокером для торговли, к собственному капиталу.'"
                            :direction = "'right'"></des>
                            <span>Кредитное плечо</span></div>
            <data-watcher :data="leverage" :mod="3"></data-watcher>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
				<des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Общее число позиций, по которым зафиксирован финансовый результат.'"
                            :direction = "'right'"></des>
                            <span>Закрытых сделок всего</span></div>
            <div class="statistica__summary-item-data  f-stat-data">{{getCountOfClosePositions.count}}</div>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Доля успешных (доходных) операций из общего числа сделок за определенный период.'"
                            :direction = "'right'"></des>
                        <span>ПРИБЫЛЬНЫХ ЗАКРЫТЫХ СДЕЛОК</span></div>
            <data-watcher :data="getCountOfClosePositions.profitDeals" :units="'q'" :mod="3"></data-watcher>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Доля успешных (доходных) операций из общего числа сделок за определенный период.'"
                            :direction = "'right'"></des>
                    <span>ПРИБЫЛЬНЫХ ЗАКРЫТЫХ СДЕЛОК, %</span></div>
            <data-watcher :data="getCountOfClosePositions.percent" :units="'%'" :mod="3"></data-watcher>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Число исполненных торговых ордеров с нулевым или отрицательным результатом.'"
                            :direction = "'right'"></des>
                    <span>УБЫТОЧНЫХ ЗАКРЫТЫХ СДЕЛОК</span></div>
            <div class="statistica__summary-item-data  f-stat-data">{{getCountOfClosePositions.count - getCountOfClosePositions.profitDeals}} ({{100 - getCountOfClosePositions.percent}}%)</div>
        </div>
        <!--<div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des :text="'Величина суммарного убытка за определенный временной диапазон по всем сделкам с отрицательным результатом.'"
                            :direction = "'right'"></des>
                            <span>Общий убыток</span></div>
            <div class="statistica__summary-item-data  f-stat-data color-red">$ {{$moneyf(getSumDown)}}</div>
        </div>-->
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                 <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Cравнительный показатель соотношения доходности и риска.'"
                            :direction = "'right'"></des>
                            <span>КОФФИЦИЕНТ ШАРПА</span></div>
            <data-watcher :data="sharp" :mod="3"></data-watcher>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Комплексный показатель, характеризующий надежность торговой стратегии и ее способность к восстановлению после потерь.'"
                            :direction = "'right'"></des>
                    <span>ФАКТОР ВОССТАНОВЛЕНИЯ</span></div>
            <data-watcher :data="factor" :mod="3"></data-watcher>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Показатель, демонстрирующий усредненный результат успешных сделок.'"
                            :direction = "'right'"></des>
                    <span>СРЕДНЯЯ ТОРГОВЛЯ</span></div>
            <data-watcher :data="avrTrade" :mod="3"></data-watcher>
        </div>
        <!--<div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des :text="'Расчетный показатель отношения средней прибыли к среднему убытку (должен быть выше 1).'"
                            :direction = "'right'"></des>
                        <span>ОТНОШЕНИЕ СР. ПРОФИТА К СР. УБЫТКУ</span></div>
            <div class="statistica__summary-item-data  f-stat-data">{{getAvrProfitOnAvrDown.toFixed(2)}}</div>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des :text="'Количество сделок типа «Buy» - позиций, открытых в расчете на рост цены актива.'"
                            :direction = "'right'"></des>
                    <span>ДЛИННЫХ ТРЕЙДОВ</span></div>
            <div class="statistica__summary-item-data  f-stat-data">{{getTraders.cntHight}}</div>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des :text="'Количество сделок типа «Sell» - позиций, открытых в расчете на падение цены актива.'"
                            :direction = "'right'"></des>
                    <span>КОРОТКИХ ТРЕЙДОВ</span></div>
            <div class="statistica__summary-item-data  f-stat-data">{{getTraders.cntShot}}</div>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des :text="'Комплексный показатель, характеризующий отношение полученной прибыли к убыткам в определенный временной интервал (должен быть выше 1).'"
                            :direction = "'right'"></des>
                    <span>ПРОФИТ ФАКТОР</span></div>
            <data-watcher :data="profitFactor"></data-watcher>
        </div>-->
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Показатель успешности торговой стратегии - отношение чистой прибыли к общему количеству закрытых сделок.'"
                            :direction = "'right'"></des>
                    <span>МАТЕМАТИЧЕСКОЕ ОЖИДАНИЕ</span></div>
            <data-watcher :data="math" :mod="3"></data-watcher>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Показатель соотношения средств, используемых в торговых операциях к общему объему депозита.'"
                                :direction = "'right'"></des>
                                <span>ЗАГРУЗКА ДЕПОЗИТА</span></div>
            <div class="statistica__summary-item-data  f-stat-data">{{getLoadDeposit.toFixed(2)}}</div>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Отношение суммарного результата всех прибыльных сделок в валюте депозита к общему количеству положительных сделок за определенный период времени.'"
                                :direction = "'right'"></des>
                                <span>СРЕДНИЙ ДОХОД НА СДЕЛКУ, $</span></div>
            <div class="statistica__summary-item-data color-green">{{(getCountOfClosePositions.avrProfit).toFixed(2)}}</div>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des icon="icon-info" icon-class="icon icon--inline" icon-size="0 0 30 30" :text="'Отношение суммарного результата всех прибыльных сделок, выраженного в процентных пунктах, к общему количеству положительных сделок за определенный период времени.'"
                                :direction = "'right'"></des>
                    <span>СРЕДНИЙ ДОХОД НА СДЕЛКУ, PIP</span></div>
            <div class="statistica__summary-item-data color-green">{{(getCountOfClosePositions.avrProfitPips).toFixed(2)}}</div>
        </div>
        <!--<div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des :text="'Отношение суммарного результата всех убыточных сделок в валюте депозита к общему количеству отрицательных сделок за определенный период времени.'"
                                :direction = "'right'"></des>
                        <span>СРЕДНИЙ УБЫТОК НА СДЕЛКУ, $</span></div>
            <div class="statistica__summary-item-data color-red">{{getAvrDown.toFixed(2)}}</div>
        </div>
        <div class="statistica__summary-item">
            <div class="statistica__summary-item-data-title">
                <des :text="'Отношение суммарного результата всех убыточных сделок, выраженного в процентных пунктах, к общему количеству отрицательных сделок за определенный период времени.'"
                                :direction = "'right'"></des>
                    <span>СРЕДНИЙ УБЫТОК НА СДЕЛКУ, PIP</span></div>
            <div class="statistica__summary-item-data color-red">{{getAvrDownPoints.toFixed(2)}}</div>
        </div>-->
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import dataWatcher from "../ui-components/ui-data-watcher"
import description from "../ui-components/description"
export default {
    components: {
        'data-watcher':dataWatcher,
        'des':description
    },
    data() {
        return {
            primaryStat:{
                Summary :{
                    Balance:0,
                    Drawdown1000:0,
                    Equity:0,
                    ProfitAbs:0,
                    ProfitPoints:0,
                    ProfitableDeals:0,
                    Sharp1000:0
                },
                DailyRecords:[{
                    Leverage:0,
                    Margin:0,
                    EquityClose:0
                }]
            },
            eq:0,
            bl:0,
            cleanProfit:0,
            cleanProfitPoint:0,
            leverage:0,
            factor:0,
            sharp:0,
            math:0,
            profitFactor:0,
            avrTrade:0
        }
    },
    computed:{
        ...mapGetters({
              getStatistics: 'accountstat/getStatistics',
              getTotalClosePosition: 'closPositions/getTotal',
              getSummaryClose: 'closSummary/getSummary',
              getStatClosePosition: 'closPositions/getPositions'
        }),
        getBalance() {
            if(this.primaryStat != 0)
            return this.$moneyf(this.primaryStat.Summary.Balance,0)
        },
        getDay() {
            if(this.primaryStat != 0)
            return this.primaryStat.DailyRecords.length
        },
        getMaxDD() {
             if(this.primaryStat != 0)
            return this.primaryStat.Summary.Drawdown1000
        },
        getClosePosition() {
            if(this.primaryStat != 0)
            return this.primaryStat.Summary.ProfitableDeals
        },
        getPercentProfitDeals() {
            if(this.primaryStat != 0)
            return Math.ceil(100/(this.getTotalClosePosition/this.getClosePosition))
        },
        getDownDeals() {
                let result = {};
                result = {
                    deals: this.getTotalClosePosition - this.getClosePosition,
                    percent: 100 - this.getPercentProfitDeals
                }
            return result
        },
        getCountOfClosePositions() {
            let allDeals = 0;
            let allProfitDeals = 0;
            let summaryProfit = 0;
            let summaryProfitPips = 0;
            for (let key in this.getSummaryClose.SumBySymbol) {
                allDeals+=this.getSummaryClose.SumBySymbol[key].Count;
                allProfitDeals+=this.getSummaryClose.SumBySymbol[key].CountProfit;
                summaryProfit+=this.getSummaryClose.SumBySymbol[key].ProfitAbs;
                summaryProfitPips+=this.getSummaryClose.SumBySymbol[key].ProfitPoints;
            }
            let percent = 100/(allDeals/allProfitDeals);
            let deals = {percent:Math.floor(percent), count:allDeals, profitDeals:allProfitDeals,
                            avrProfit: summaryProfit/allDeals, avrProfitPips:summaryProfitPips/allDeals}
            return deals;
        },
        getSummaryProfit() {
            let sumProfit = {
                abs:0,
                pips:0
            }
            let abs = 0;
            let pips = 0;
            for(let key in this.getSummaryClose.SumBySymbol) {
                abs+=this.getSummaryClose.SumBySymbol[key].ProfitAbs
                pips+=this.getSummaryClose.SumBySymbol[key].ProfitPoints
            }
            return sumProfit = {
                abs:abs,
                pips:pips
            };
        },
        getTraders() {
            let countTraders = {
                cntShot:0,
                cntHight:0
            };
            for(let i = 0; i < this.getStatClosePosition.length; i++)
            {
                if (this.getStatClosePosition[i].side < 0) {
                    countTraders.cntShot++;
                }
                else {
                    countTraders.cntHight++;
                }
            }
            return countTraders;
        },
        getSumDown() {
            let sumDown = 0;
            for(let i = 0; i < this.getStatClosePosition.length; i++)
            {
                if (this.getStatClosePosition[i].resultDepo < 0) {
                    sumDown+=this.getStatClosePosition[i].resultDepo;
                }
            }
            return sumDown;
        },
        getSumDownPoint() {
            let sumDown = 0;
            for(let i = 0; i < this.getStatClosePosition.length; i++)
            {
                if (this.getStatClosePosition[i].resultPoint < 0) {
                    sumDown+=this.getStatClosePosition[i].resultPoint;
                }
            }
            return sumDown;
        },
        getAvrDown() {
            let cnt = [];
            for(let i = 0; i < this.getStatClosePosition.length; i++)
            {
                if (this.getStatClosePosition[i].resultDepo < 0) {
                    cnt.push(this.getStatClosePosition[i].resultDepo)
                }
            }
            return this.getSumDown/cnt.length
        },
        getAvrDownPoints() {
            let cnt = [];
            for(let i = 0; i < this.getStatClosePosition.length; i++)
            {
                if (this.getStatClosePosition[i].resultPoint < 0) {
                    cnt.push(this.getStatClosePosition[i].resultPoint)
                }
            }
            return this.getSumDownPoint/cnt.length
        },
        getAvrProfit() {
            let cnt = [];
            for(let i = 0; i < this.getStatClosePosition.length; i++)
            {
                if (this.getStatClosePosition[i].resultDepo > 0) {
                    cnt.push(this.getStatClosePosition[i].resultDepo)
                }
            }
            return this.getSummaryProfit.abs/cnt.length
        },
        getAvrProfitPoints() {
            let cnt = [];
            for(let i = 0; i < this.getStatClosePosition.length; i++)
            {
                if (this.getStatClosePosition[i].resultPoint > 0) {
                    cnt.push(this.getStatClosePosition[i].resultPoint)
                }
            }
            return this.getSummaryProfit.pips/cnt.length
        },
        getAvrProfitOnAvrDown() {
            return this.getAvrProfit/this.getAvrDown*-1
        },
        getLoadDeposit() {
            return (this.primaryStat.DailyRecords[this.primaryStat.DailyRecords.length - 1].Margin/this.primaryStat.Summary.Equity)*100
        }

    },
    methods: {
        updateData() {
            let stat = this.getStatistics('');
               if (!stat) {
                return;
               }
               this.factor = stat.Summary.ProfitAbs/stat.Summary.Drawdown1000
               this.eq = stat.DailyRecords[stat.DailyRecords.length - 1].EquityClose;
               this.bl = stat.DailyRecords[stat.DailyRecords.length - 1].BalanceClose;
               this.cleanProfit = stat.Summary.ProfitAbs;
               this.sharp = stat.Summary.Sharp1000;
               this.avrTrade = stat.Summary.ProfitAbs/stat.Summary.TotalDeals;
               this.math = stat.Summary.ProfitPoints/stat.Summary.TotalDeals;
               this.cleanProfitPoint = stat.Summary.ProfitPoints;
               this.leverage = stat.DailyRecords[stat.DailyRecords.length - 1].Leverage
               this.primaryStat = stat
               this.profitFactor = stat.Summary.ProfitAbs/this.getSumDown
        }
    },
    created () {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
               this.updateData()
        });
        this.updateData()
        //let query = { pageLength: 1500, page: 0, symbol: '' }
        //this.$store.dispatch("closPositions/readPositionsFromServer", query)
    }

}
function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "statistic-summary-tableWidgetTablet",
            handler: handler
        }
    });
}
</script>
<style lang="less" scoped>
.statistica {
    &__summary {
        width: 360px;
        background-color: #3d536b;
        display: block;
        color: #fff;
        border-radius: 4px;
        margin-bottom: 8px;
        margin-top: 0px;
        &-item {
            border-bottom: 1px solid #374b62;
            display: flex;
            justify-content: space-between;
            &-title {
                font-family: Montserrat;
                font-size: 14px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 3;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding: 0 12px;
            }
            &-data {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2.33;
                letter-spacing: 0.4px;
                margin-right: 12px;
                    span {
                        margin-left:12px;
                    }

                    &-title {
                        font-family: Arimo;
                        display: flex;
                        align-items: center;
                        font-size: 10px;
                        font-weight: bold;
                        font-style: normal;
                        font-stretch: normal;
                        line-height: 1;
                        letter-spacing: 0.4px;
                        margin-left: 12px;
                        color:#adc4e1;
                        text-transform: uppercase;

                        span {
                            margin-left: 3px;
                        }
                    }
                }
            }
        }

}
</style>

